let URL;
let appMode = process.env.REACT_APP_ENV;
let ASSET_URL = "http://103.189.173.7:3369/api";

if (appMode === "development") {
  URL = "http://103.189.173.7:3369/api";
} else {
  // URL = "http://103.189.173.7:3369/api";
  // URL = "http://localhost:3369/api";
  // URL = "http://127.0.0.1:8000";
  URL = "https://api-staging.duepaynz.com";
  // URL = "http://45.194.47.66:7575";
  // URL = "http://34.129.155.143:8000";
}

// 153.92.4.13:6555

let apiPath = {
  socketURL: "wss://api-staging.duepaynz.com/ws/socket/",
  baseURL: URL,
  assetURL: ASSET_URL,
  dashboard: "admin/dashboard",

  // Auth API
  logout: "admin/auth/logout",

  login: "admin/auth/login",
  publicKey: "admin/auth/public-key",
  exchangeKey: "admin/auth/exchange-key",
  profile: "admin/auth/get-profile",
  updateProfile: "admin/auth/update-profile",
  changePassword: "admin/auth/change-password",
  updateAppSetting: "admin/auth/update-app-setting",
  forgotPassword: "admin/auth/forgot-password",
  verifyOTP: "admin/auth/verify-otp",
  resetPassword: "admin/auth/reset-password",

  //notification
  notification: "admin/notification",
  notificationUser: "admin/notification/notification-user",

  //help-center
  helpCenter: "admin/help-center",

  // Other APIs
  customerManager: "admin/user",
  postManager: "admin/posts",
  productManager: "admin/products",
  productCategories: "admin/products/categories",
  productAddCategory: "admin/products/add-category",
  productUpdateCategory: "admin/products/update-category",
  productDeleteCategory: "admin/products/categories",
  documentCategories: "document-categories",
  labs: "labs",
  vendorSubscriptionManager: "admin/vendor-subscription",
  userSubscriptionManager: "admin/user-plans",
  subscriptions: "admin/subscription",
  userSubscriptions: "admin/user-subscription",
  setCommission: "admin/auth/commission",
  teamManager: "admin/team",
  surveyManger: "admin/survey",
  vendors: "admin/vendors",

  // Finance APIs
  finance: {
    transactions: "admin/finance/transactions",
    payouts: "admin/finance/payouts",
    expenses: "admin/finance/expenses",
    tokens: {
      issued: "admin/finance/tokens/issued",
      redeemed: "admin/finance/tokens/redeemed",
      issuedExport: "admin/finance/tokens/issued/export",
      redeemedExport: "admin/finance/tokens/redeemed/export",
    },
    ledger: "admin/finance/ledger",
    ledgerExport: "admin/finance/ledger/export",
  },

  // Auctions APIs
  auctions: {
    list: "admin/auctions",
    requests: "admin/auctions/requests/list",
    export: "admin/auctions/export",
    close: "admin/auctions",
    delete: "admin/auctions",
    cancel: "admin/auctions",
    selectWinner: "admin/auctions",
    approveRequest: "admin/auctions/requests",
    rejectRequest: "admin/auctions/requests",
  },

  // Games APIs
  games: {
    list: "admin/games",
    genres: "admin/genres",
    tiers: "admin/games",
    leaderboard: "admin/games",
  },

  // Global Ranks APIs
  globalRanks: {
    list: "admin/global-ranks",
    create: "admin/global-ranks",
    update: "admin/global-ranks",
    delete: "admin/global-ranks",
    status: "admin/global-ranks",
    leaderboard: "admin/global-ranks/leaderboard",
  },

  // Tournaments APIs
  tournaments: {
    list: "admin/tournaments",
    leaderboard: "admin/tournaments",
  },

  // Global Badges APIs
  badges: {
    list: "admin/badges",
    create: "admin/badges",
    update: "admin/badges",
    delete: "admin/badges",
    status: "admin/badges",
  },

  // Content APIs
  listContent: "admin/content/list",
  editContent: "admin/content/edit",
  statusContent: "admin/content/status",
  viewContent: "admin/content/view",

  common: {
    userOrVendors: "common/user-or-vendor",
    vendors: "common/vendor",
  },
};

export default apiPath;
